import {request} from '@/utils/request'

// 用户登录
export function login(data) {
    return request({
        url: '/people/auth/login',
        method: 'post',
        data
    })
}
export function getSwiperDetail(id) {
    return request({
        url: '/system/getSwiperDetail/'+id,
        method: 'get'
    })
}


// pc扫码登录
export function login_pc_qrcode() {
    return request({
        url: '/login_pc_qrcode',
        method: 'get',
    })
}

// 展示二维码
export function show_bind_wechat() {
    return request({
        url: '/people/show_bind_wechat',
        method: 'get',
    })
}

// 展示二维码
export function bind_wechat(data) {
    return request({
        url: '/bind_wechat',
        method: 'get',
        data
    })
}

// 忘记密码
export function forget_password(data) {
    return request({
        url: 'people/forget_password',
        method: 'post',
        data
    })
}

// pc扫码登录回调
export function callback(data) {
    return request({
        url: '/wechat/callback',
        method: 'get',
        data
    })
}

// 检查手机号是否被使用过
export function checkPhone(data) {
    return request({
        url: '/people/checkPhone',
        method: 'post',
        data
    })
}

// 检查手机号是否被使用过
export function sendSmsCode(data) {
    return request({
        url: '/people/auth/sendSmsCode',
        method: 'get',
        data
    })
}

// PC授权登录后绑定手机号
export function bindPhone(data) {
    return request({
        url: '/people/bindPhone',
        method: 'post',
        data
    })
}

// 验证码登录
export function loginForCode(data) {
    return request({
        url: '/people/auth/loginForCode',
        method: 'post',
        data
    })
}

// 注册
export function register(data) {
    return request({
        url: '/people/register',
        method: 'post',
        data
    })
}

// 获取用户地址
export function getUserAddress(data) {
    return request({
        url: '/people/address',
        method: 'get',
        data
    })
}

// 添加用户地址
export function addressAdd(data) {
    return request({
        url: '/people/address',
        method: 'post',
        data
    })
}

// 修改用户地址
export function addressUpdate(id, data) {
    return request({
        url: '/people/address/' + id,
        method: 'put',
        data
    })
}

// 删除用户地址
export function addressDelete(id) {
    return request({
        url: '/people/address/' + id,
        method: 'POST',
        data: {
            _method: 'DELETE'
        }
    })
}

// 获取用户地址
export function getAddressDetail(id) {
    return request({
        url: '/people/address/' + id,
        method: 'get'
    })
}

// 获取用户发票列表
export function invoiceList() {
    return request({
        url: '/people/invoice',
        method: 'get'
    })
}

// 添加用户发票
export function invoiceAdd(data) {
    return request({
        url: '/people/invoice',
        method: 'post',
        data
    })
}

// 修改用户发票
export function invoiceUpdate(id, data) {
    return request({
        url: '/people/invoice/' + id,
        method: 'put',
        data
    })
}

// 删除用户发票
export function invoiceDelete(id) {
    return request({
        url: '/people/invoice/' + id,
        method: 'delete'
    })
}

// 获取用户发票详情
export function invoiceDetail(id) {
    return request({
        url: '/people/invoice/' + id,
        method: 'get'
    })
}

// 获取用户收款账户列表
export function accountList() {
    return request({
        url: '/people/account',
        method: 'get'
    })
}

// 添加用户收款账户
export function accountAdd(data) {
    return request({
        url: '/people/account',
        method: 'post',
        data
    })
}

// 修改用户收款账户
export function accountUpdate(id, data) {
    return request({
        url: '/people/account/' + id,
        method: 'put',
        data
    })
}

// 删除用户收款账户
export function accountDelete(id) {
    return request({
        url: '/people/account/' + id,
        method: 'delete'
    })
}

// 获取用户收款账户详情
export function accountDetail(id) {
    return request({
        url: '/people/account/' + id,
        method: 'get'
    })
}

// 获取用户信息
export function getUserInfo() {
    return request({
        url: '/people/getUserInfo',
        method: 'get'
    })
}

// 修改用户信息
export function editInfo(data) {
    return request({
        url: '/people/editInfo',
        method: 'post',
        data
    })
}
// 修改用户信息
export function updateUserInfonew(data) {
    return request({
        url: '/people/updateUserInfo',
        method: 'post',
        data
    })
}

// 修改用户密码
export function editPassword(data) {
    return request({
        url: '/people/editPassword',
        method: 'post',
        data
    })
}

// 添加采购订单
export function purchaseAdd(data) {
    return request({
        url: '/purchase/api/purchase',
        method: 'post',
        data
    })
}

// 获取采购订单列表
export function purchaseList(data) {
    return request({
        url: '/purchase/api/lst',
        method: 'get',
        data
    })
}

// 获取采购订单详情
export function purchaseDetail(id) {
    return request({
        url: '/purchase/detail/' + id,
        method: 'get'
    })
}

// 获取采购订单报价历史
export function quote_history(cas, data) {
    return request({
        url: '/purchase/quote_history/' + cas,
        method: 'get',
        data
    })
}

// 获取采购订单报价历史
export function quote_list_api(id) {
    return request({
        url: '/purchase/quote_list_api/' + id,
        method: 'get'
    })
}

// 获取采购订单CAS号是否存在
export function checkCasNo(cas) {
    return request({
        url: '/purchase/checkCasNo/' + cas,
        method: 'get'
    })
}

// 结束报价
export function end_quote(id) {
    return request({
        url: '/purchase/end_quote/' + id,
        method: 'put'
    })
}

// 获取采购订单列表
export function purchase_order(data) {
    return request({
        url: '/order/purchase_order',
        method: 'get',
        data
    })
}

// 获取报价管理列表
export function quote_list(data) {
    return request({
        url: '/supply/quote_list',
        method: 'get',
        data
    })
}

// 发布产品
export function productAdd(data) {
    return request({
        url: '/supply/product',
        method: 'post',
        data
    })
}

// 获取产品列表
export function productList(data) {
    return request({
        url: '/supply/product',
        method: 'get',
        data
    })
}

// 修改产品起订量
export function order_product_number(id, data) {
    return request({
        url: '/supply/order_product/' + id,
        method: 'put',
        data
    })
}

// 修改产品上下架状态
export function product_enable(id, data) {
    return request({
        url: '/supply/enable_product/' + id,
        method: 'put',
        data
    })
}

// 修改产品置顶状态
export function top_product(id, data) {
    return request({
        url: '/supply/top_product/' + id,
        method: 'put',
        data
    })
}

// 我要报价
export function quote_product(id, data) {
    return request({
        url: '/supply/quote_product/' + id,
        method: 'put',
        data
    })
}

// 放弃报价
export function give_up_quote(id, data) {
    return request({
        url: '/supply/give_up_quote/' + id,
        method: 'put',
        data
    })
}

// 我的产品详情
export function product_detail(id, data) {
    return request({
        url: '/supply/product/' + id,
        method: 'get',
        data
    })
}

// 报价管理详情
export function quote_detail(id, data) {
    return request({
        url: '/supply/quote_detail/' + id,
        method: 'get',
        data
    })
}

// 立即购买
export function order_buy(data) {
    return request({
        url: '/order/order',
        method: 'post',
        data
    })
}

// 报价详情
export function quote_detail_get(id, data) {
    return request({
        url: '/purchase/quote_detail/' + id,
        method: 'get',
        data
    })
}

// 报价表报价详情
export function quote_detail_d(id, data) {
    return request({
        url: '/purchase/quote_detail_d/' + id,
        method: 'get',
        data
    })
}

// 支付订单
export function pay_order(id, data) {
    return request({
        url: '/order/pay_order/' + id,
        method: 'put',
        data
    })
}

// 订单详情
export function purchase_order_detail(id) {
    return request({
        url: '/order/purchase_order/' + id,
        method: 'get'
    })
}

// 订单详情
export function completeProductInfo(id, data) {
    return request({
        url: '/supply/completeProductInfo/' + id,
        method: 'put',
        data
    })
}

/**
 * 确认产品备注
 * @param id
 * @param data
 * @returns {Promise<unknown>}
 */
export function confirmProductRemark(id,data){
    return request({
        url: '/supply/confirmProductRemark/' + id,
        method: 'put',
        data
    })
}

// 删除产品
export function productDelete(id) {
    return request({
        url: '/supply/product/' + id,
        method: 'delete'
    })
}

// 销售订单列表
export function supplier_order_list(data) {
    return request({
        url: '/order/supplier_order',
        method: 'get',
        data
    })
}

// 技术供需新增
export function addTech(data) {
    return request({
        url: '/tech/tech',
        method: 'post',
        data
    })
}

// 技术供需编辑
export function editTech(id, data) {
    return request({
        url: 'tech/tech/' + id,
        method: 'put',
        data
    })
}

// 技术供需列表
export function techList(data) {
    return request({
        url: '/tech/tech',
        method: 'get',
        data
    })
}

// 结束技术供需
export function techEnd(id) {
    return request({
        url: '/tech/end/' + id,
        method: 'put'
    })
}

// 技术供需详情
export function techDetail(id) {
    return request({
        url: '/tech/tech/' + id,
        method: 'get'
    })
}

// 删除技术供需
export function techDelete(id) {
    return request({
        url: '/tech/tech/' + id,
        method: 'delete'
    })
}

// 标记为已完成转让
export function success(id) {
    return request({
        url: '/tech/success/' + id,
        method: 'put'
    })
}

// 标记为找到合适供需
export function find(id) {
    return request({
        url: '/tech/find/' + id,
        method: 'put'
    })
}

// 发货
export function delivery(id, data) {
    return request({
        url: '/order/delivery/' + id,
        method: 'put',
        data
    })
}

// 申请合同
export function apply_contract(id, data) {
    return request({
        url: '/order/apply_contract/' + id,
        method: 'put',
        data
    })
}

// 确认收货
export function confirm_receipt(id, data) {
    return request({
        url: '/order/confirm_receipt/' + id,
        method: 'put',
        data
    })
}

// 申请发票
export function apply_invoice(id, data) {
    return request({
        url: '/order/apply_invoice/' + id,
        method: 'put',
        data
    })
}

// 新增来料加工
export function processAdd(data) {
    return request({
        url: '/proces/proces',
        method: 'post',
        data
    })
}

// 来料加工列表
export function processList(data) {
    return request({
        url: '/proces/proces',
        method: 'get',
        data
    })
}

// 提交价格
export function price_product(id, data) {
    return request({
        url: '/supply/price_product/' + id,
        method: 'put',
        data
    })
}

// 获取价格
export function price_product_edit(id, data) {
    return request({
        url: '/supply/price_product/' + id,
        method: 'get',
        data
    })
}

// 修改价格
export function updatePrice(id, data) {
    return request({
        url: '/supply/updatePrice/' + id,
        method: 'put',
        data
    })
}

// 修改价格
export function delete_price(id) {
    return request({
        url: '/supply/delete_price/' + id,
        method: 'delete'
    })
}

// 来料加工详情
export function procesDetail(id) {
    return request({
        url: '/proces/proces/' + id,
        method: 'get'
    })
}

// 来料加工删除
export function procesDelete(id) {
    return request({
        url: '/proces/proces/' + id,
        method: 'delete'
    })
}

// 来料加工编辑
export function procesEdit(id, data) {
    return request({
        url: '/proces/proces/' + id,
        method: 'put',
        data
    })
}

// 获取消息配置
export function get_config() {
    return request({
        url: '/message/get_config',
        method: 'get'
    })
}

// S设置消息配置
export function setSetting(data) {
    return request({
        url: '/message/setSetting/' + data.key,
        method: 'put',
    })
}

// 提交投诉建议
export function feedback(data) {
    return request({
        url: '/message/feedback',
        method: 'post',
        data
    })
}

// 投诉建议列表
export function feedbackList(data) {
    return request({
        url: '/message/feedback_list',
        method: 'get',
        data
    })
}

// 投诉建议详情
export function feedbackDetail(id) {
    return request({
        url: '/message/feedback_list/' + id,
        method: 'get',
    })
}

// 消息列表
export function messageList(data) {
    return request({
        url: '/message/message',
        method: 'get',
        data
    })
}

// 消息详情
export function messageDetail(id) {
    return request({
        url: '/message/message/' + id,
        method: 'get',
    })
}

// 采购到期
export function expire_purchase(data) {
    return request({
        url: '/purchase/expire_purchase/',
        method: 'get',
        data
    })
}

// 获取我的客服
    export function getMyCustomerService(data) {
        return request({
            url: '/people/getMyCustomerService',
            method: 'get'
        })
    }

// 修改购物车数量
export function changeNum(id, data) {
    return request({
        url: '/order/changeNum/' + id,
        method: 'put',
        data
    })
}

// 创建订单
export function create_order_by_cart(data) {
    return request({
        url: '/order/create_order_by_cart',
        method: 'post',
        data
    })
}

// 立即购买
export function create_order_buy_now(data) {
    return request({
        url: '/order/create_order_buy_now',
        method: 'post',
        data
    })
}

// 由订单号获取订单信息
export function get_order_by_orderno(orderno) {
    return request({
        url: '/order/get_order_by_orderno/' + orderno,
        method: 'get'
    })
}

// 由订单id获取订单信息
export function get_order_by_orderid(id) {
    return request({
        url: '/order/get_order_by_orderid/' + id,
        method: 'get'
    })
}

// 统一支付
export function unifiedPayment(data) {
    return request({
        url: '/pay/unifiedPayment',
        method: 'post',
        data
    })
}

// 更新用户信息
export function updateUserInfo(data) {
    return request({
        url: '/user/update',
        method: 'post',
        data
    })
}
// 更新用户信息
export function getUpgradeSvipPrice(data) {
    return request({
        url: '/people/members/getUpgradeSvipPrice',
        method: 'get',
        data
    })
}
// 获取运费
export function calculateShippingCost(data) {
    return request({
        url: '/shop/calculateShippingCost',
        method: 'post',
        data
    })
}

// 特殊情况下跳过默认错误处理（比如静默请求）
export function silentRequest() {
    return request({
        url: '/api/silent',
        method: 'get',
        skipErrorHandler: true // 跳过默认错误处理
    }).catch(err => {
        // 这里可以自定义错误处理
        console.log('静默请求失败:', err)
    })
}
